import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less']
})
export class LayoutFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
